// extracted by mini-css-extract-plugin
module.exports = {"aside":"Sidebar_aside__cIxyN","active":"Sidebar_active__1WF5H"};